import { render, staticRenderFns } from "./VCollapse.vue?vue&type=template&id=0cdce3a1&scoped=true&"
import script from "./VCollapse.vue?vue&type=script&lang=js&"
export * from "./VCollapse.vue?vue&type=script&lang=js&"
import style0 from "./VCollapse.vue?vue&type=style&index=0&id=0cdce3a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdce3a1",
  null
  
)

export default component.exports